
import React, { useState } from 'react';
import { Button } from '@/components/ui/button';
import { EditIcon } from 'lucide-react';
import { ReportData } from '@/types/report';
import { EditReportDialog } from './EditReportDialog';
import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';

interface ReportEditButtonProps {
  reportId: string;
  onSuccess?: () => void;
}

export const ReportEditButton = ({ reportId, onSuccess }: ReportEditButtonProps) => {
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  
  const { data: report, refetch } = useQuery({
    queryKey: ['report', reportId],
    queryFn: async () => {
      const { data, error } = await supabase
        .from('student_development_reports')
        .select('*')
        .eq('id', reportId)
        .single();
        
      if (error) throw error;
      return data as ReportData;
    },
    enabled: false,
  });

  const handleEditClick = async () => {
    await refetch();
    setIsDialogOpen(true);
  };

  const handleSuccess = () => {
    if (onSuccess) onSuccess();
  };

  return (
    <>
      <Button 
        variant="ghost" 
        size="sm" 
        onClick={handleEditClick} 
        className="hover:text-blue-600"
      >
        <EditIcon className="h-4 w-4 mr-1" />
        แก้ไข
      </Button>
      
      <EditReportDialog
        report={report}
        isOpen={isDialogOpen}
        onClose={() => setIsDialogOpen(false)}
        onSuccess={handleSuccess}
      />
    </>
  );
};
